import * as React from 'react';
export const VESvg = React.forwardRef(function VESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1.994 2A1.992 1.992 0 0 0 0 4v2h16V4c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 6V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2H0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M4.5 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM6 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1.5-.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM9 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1.5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z',
      }),
    ),
  );
});
VESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var VE = {
  category: 'flag',
  colorable: false,
  name: 'VE',
  svg: VESvg,
};
